import { useState, useEffect, useCallback } from 'react'
import { useMintManagerContract } from './useContract'
import { BigNumber } from 'bignumber.js'
import Web3 from 'web3'

export const useGetMintCost = (amount, immediate = true) => {
  const [isLoading, setIsLoading] = useState(false)
  const [value, setValue] = useState(null)
  const [error, setError] = useState(null)

  const mintManagerContract = useMintManagerContract()

  const execute = useCallback(async () => {
    if (!mintManagerContract) return

    setIsLoading(true)
    setValue(null)
    setError(null)

    try {
      const publicSalePrice = await mintManagerContract.methods
        .mintPricePublic()
        .call()

      const mintCost = Web3.utils.fromWei(
        new BigNumber(publicSalePrice).times(amount).toString(), 'ether'
      )

      setValue(mintCost)
    } catch (err) {
      setError(err)
    } finally {
      setIsLoading(false)
    }
  }, [mintManagerContract, amount])

  useEffect(() => {
    if (immediate) {
      execute()
    }
  }, [execute, immediate])
  return { execute, isLoading, value, error }
}

export default useGetMintCost
